import { ApiService } from '../../../../../services/api.service';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest } from 'rxjs';
var SellerFormComponent = (function () {
    function SellerFormComponent(formBuilder, apiService) {
        this.formBuilder = formBuilder;
        this.apiService = apiService;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.username = localStorage.getItem('username');
        this.isSellerHeadOffice = false;
    }
    SellerFormComponent.prototype.ngOnInit = function () {
        this.createSellerForm();
        // any time the inner form changes update the parent of any change
        this.createSubscriptions();
        this.getCountries();
        this.getSeller();
    };
    SellerFormComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    SellerFormComponent.prototype.writeValue = function (value) {
        if (value) {
            this.sellerForm.setValue(value);
            this.onChange(value);
            this.onTouched();
        }
    };
    SellerFormComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SellerFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // communicate the inner form validation to the parent form
    SellerFormComponent.prototype.validate = function (_control) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.sellerForm.valid ? resolve(null) : resolve({ sellerForm: { valid: false } });
        });
    };
    SellerFormComponent.prototype.createSubscriptions = function () {
        var _this = this;
        // Subscribe to valueChanges and statusChanges
        this.subscription = combineLatest([this.sellerForm.valueChanges, this.sellerForm.statusChanges]).subscribe(function () {
            var selectedSeller = _this.sellers.find(function (seller) { return seller.name === _this.sellerName.value; });
            var selectedBranch = selectedSeller ? selectedSeller.branch.find(function (branch) { return branch.code === _this.sellerBranchCode.value; }) : null;
            var engData = {
                nameEN: selectedSeller ? selectedSeller.name_en : null,
                addressEN: selectedBranch ? selectedBranch.address_en : null
            };
            _this.onChange(Object.assign({}, _this.sellerForm.getRawValue(), engData));
            _this.onTouched();
        });
    };
    SellerFormComponent.prototype.getSeller = function () {
        var _this = this;
        this.apiService.getCompany().subscribe(function (res) {
            _this.sellers = res || [];
            if (_this.sellers.length === 1) {
                _this.setSeller(_this.sellers[0]);
            }
        });
    };
    SellerFormComponent.prototype.getCountries = function () {
        var _this = this;
        this.apiService.getCountry().subscribe(function (res) {
            _this.countries = res;
        });
    };
    Object.defineProperty(SellerFormComponent.prototype, "sellerBranches", {
        get: function () {
            var _this = this;
            var seller = this.sellers ? this.sellers.find(function (sellerItem) { return sellerItem.name === _this.sellerName.value; }) : null;
            return seller ? seller.branch : [];
        },
        enumerable: true,
        configurable: true
    });
    SellerFormComponent.prototype.createSellerForm = function () {
        this.sellerForm = this.formBuilder.group({
            name: [null, Validators.required],
            taxID: [{ value: null, disabled: true }, Validators.required],
            branchCode: [{ value: null, disabled: true }],
            branchName: [{ value: null, disabled: true }],
            address: [{ value: null, disabled: true }, Validators.required],
            postalCode: [{ value: null, disabled: true }, Validators.required]
        });
    };
    Object.defineProperty(SellerFormComponent.prototype, "sellerName", {
        get: function () {
            return this.sellerForm.get('name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerFormComponent.prototype, "sellerTaxID", {
        get: function () {
            return this.sellerForm.get('taxID');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerFormComponent.prototype, "sellerBranchCode", {
        get: function () {
            return this.sellerForm.get('branchCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerFormComponent.prototype, "sellerBranchName", {
        get: function () {
            return this.sellerForm.get('branchName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerFormComponent.prototype, "sellerAddress", {
        get: function () {
            return this.sellerForm.get('address');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerFormComponent.prototype, "sellerPostalCode", {
        get: function () {
            return this.sellerForm.get('postalCode');
        },
        enumerable: true,
        configurable: true
    });
    SellerFormComponent.prototype.setSeller = function (seller) {
        var name = seller ? seller.name : null;
        this.sellerName.setValue(name);
        this.setSellerBranch(null);
        if (seller.branch.length === 1) {
            this.sellerBranchCode.disable();
            this.setSellerBranch(seller.branch[0]);
        }
        else {
            this.sellerBranchCode.enable();
        }
    };
    SellerFormComponent.prototype.setSellerBranch = function (branch) {
        var _this = this;
        var taxID = this.sellers.find(function (seller) { return seller.name === _this.sellerName.value; }).tax_id;
        var branchCode = branch ? branch.code : null;
        var branchName = branch ? branch.name : null;
        var address = branch ? branch.address : null;
        var postalCode = branch ? branch.post_code : null;
        var rdID = branch ? branch.rd_id : null;
        this.isSellerHeadOffice = branchCode === '00000' ? true : false;
        this.sellerForm.patchValue({
            taxID: rdID ? (taxID + rdID) : null,
            branchCode: branchCode,
            branchName: branchName,
            address: address,
            postalCode: postalCode
        });
    };
    SellerFormComponent.prototype.setSellerHeadOffice = function () {
        if (this.isSellerHeadOffice) {
            var branch = this.sellerBranches.find(function (sellerBranche) { return sellerBranche.code === '00000'; });
            this.setSellerBranch(branch);
        }
        else {
            this.setSellerBranch(null);
        }
    };
    return SellerFormComponent;
}());
export { SellerFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/seller-form/seller-form.component.ts.pre-build-optimizer.js